import { observable, computed, action } from 'mobx';
import _ from 'lodash';

import TcFileStore from './../files/tcfile-store';
import ReportStore from './../reports/report-store';
import CoordinatorDetailStore from './../coordinators/coordinator-detail-store';
import ViewStore from './view-store';
import AuthStore from './auth-store';
import CoordinatorStore from '../coordinators/coordinator-store';
import AddressLookupStore from './../files/addresslookup-store';
import TransactionStore from '../transaction/transaction-store';
import ListingStore from '../listings/listing-store';
import AgentStore from '../agents/agent-store';
import AgentProfileStore from '../agent-profile/agent-profile-store';
import DashboardStore from '../dashboard/dashboard-store';
import InvoiceStore from '../invoice/invoice-store';
import WorkflowStore from '../workflow/workflow-store';
import AnalyticsResource from '../resources/analytics-resource';
import PermissionStore from './permission-store';
import FeatureFlagStore from '../featureflags/featureflag-store';
import EmailTemplateStore from '../template/emailtemplate-store';

export default class AppStore {
    isLoadingMap = observable.map();

    constructor() {
        this.tcFileStore = new TcFileStore(this);
        this.reportStore = new ReportStore(this);
        this.coordinatorDetailStore = new CoordinatorDetailStore(this);
        this.coordinatorStore = new CoordinatorStore(this);
        this.viewStore = new ViewStore(this);
        this.authStore = new AuthStore(this);
        this.addressLookupStore = new AddressLookupStore(this);
        this.transactionStore = new TransactionStore(this);
        this.listingStore = new ListingStore(this);
        this.agentStore = new AgentStore(this);
        this.agentProfileStore = new AgentProfileStore(this);
        this.dashboardStore = new DashboardStore(this);
        this.invoiceStore = new InvoiceStore(this);
        this.workflowStore = new WorkflowStore(this);
        this.permissionStore = new PermissionStore(this);
        this.analytics = new AnalyticsResource();
        this.featureFlagStore = new FeatureFlagStore(this);
        this.emailTemplateStore = new EmailTemplateStore(this);

        this.isLoadingMap.set('tcFileStore', this.tcFileStore);
        this.isLoadingMap.set('listingStore', this.listingStore);
        this.isLoadingMap.set('transactionStore', this.transactionStore);
        this.isLoadingMap.set('invoiceStore', this.invoiceStore);
        this.isLoadingMap.set('workflowStore', this.workflowStore);
    }

    @computed
    get isLoading() {
        return _.some(this.isLoadingMap.values(), { isLoading: true });
    }
    @action
    addIsLoadingStore(name, store) {
        this.isLoadingMap.set(name, store);
    }
    @action
    removeIsLoadingStore(name, store) {
        this.isLoadingMap.delete(name);
    }
}



// WEBPACK FOOTER //
// ./src/app-main/app-store.js